export class CustomAgendaAllocationRequestType {
	public index;

	constructor(obj) {
		this.index = obj.index;
	}
} 
